var giphy_viewer_default = {
  "giphyWrapper": "_8FxqA",
  "giphy_player": "_-1w37",
  "playIcon": "c81ju",
  "gifRatio": "NpVnz"
};
export {
  giphy_viewer_default as default
};
//# sourceMappingURL=giphy-viewer-scss.js.map
